import React from 'react';
import PropTypes from 'prop-types';

// reactstrap's ModalHeader always renders its title in a flex row alongside the close button;
// without min-width: 0 a long title cannot shrink and overflows the modal instead of truncating.
// Pass this as the `tag` prop of a ModalHeader to make its title ellipsize instead of overflowing.
const TruncatedModalTitle = ({className, children}) => (
    <h5 className={`${className} text-truncate`} style={{minWidth: 0}}>{children}</h5>
);

TruncatedModalTitle.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default TruncatedModalTitle;
